// Data service for API communication with Redis backend
const API_BASE_URL = import.meta.env.PROD 
  ? '/api/data' 
  : 'http://localhost:5000/api/data';

export const dataService = {
  async get<T>(key: string): Promise<T | null> {
    try {
      const response = await fetch(`${API_BASE_URL}?key=${encodeURIComponent(key)}`);
      if (!response.ok) {
        console.error('Failed to fetch data:', response.statusText);
        return null;
      }
      const data = await response.json();
      return data as T;
    } catch (error) {
      console.error('Error fetching data:', error);
      // Fallback to localStorage in development
      if (!import.meta.env.PROD) {
        const localData = localStorage.getItem(key);
        return localData ? JSON.parse(localData) : null;
      }
      return null;
    }
  },

  async set<T>(key: string, value: T): Promise<boolean> {
    try {
      const response = await fetch(`${API_BASE_URL}?key=${encodeURIComponent(key)}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(value),
      });
      
      if (!response.ok) {
        console.error('Failed to save data:', response.statusText);
        return false;
      }
      
      // Also save to localStorage as backup
      localStorage.setItem(key, JSON.stringify(value));
      return true;
    } catch (error) {
      console.error('Error saving data:', error);
      // Fallback to localStorage
      localStorage.setItem(key, JSON.stringify(value));
      return false;
    }
  },

  async delete(key: string): Promise<boolean> {
    try {
      const response = await fetch(`${API_BASE_URL}?key=${encodeURIComponent(key)}`, {
        method: 'DELETE',
      });
      
      if (!response.ok) {
        console.error('Failed to delete data:', response.statusText);
        return false;
      }
      
      localStorage.removeItem(key);
      return true;
    } catch (error) {
      console.error('Error deleting data:', error);
      localStorage.removeItem(key);
      return false;
    }
  },
};
